// https://github.com/facebook/react/issues/14010#issuecomment-433788147
import Dashboard from 'assets/js/classes/Dashboard'
import FrontendRoutes from 'assets/js/classes/FrontendRoutes'
import handleToast from './handleToast'

// eventTaskCreated(data, modelContext, toastsContext)
export default function eventTaskCreated({ author, user, task }, { dashboard, searchBar }, { toasts, toastsDispatch, updateToasts, navigate }) {  
  [dashboard, searchBar].forEach(({ dataset, dispatch, prop, update }) => {
    Dashboard.eventTaskCreated(task, dataset);
    update(dispatch, { [prop]: dataset });
  });
  
  if (author?.id === user?.id) return;  // Don't throw toast.

  handleToast({
    title: 'Task Created', 
    message: `Task #${task?.id} was created by ${author?.name} (${author?.email}). The latest version has automatically been loaded for you.`,
    autohide: true, 
    label: 'View Task', 
    callback: () => navigate(FrontendRoutes.PROJECTS_TASK(task?.id)), 
  }, { toasts, toastsDispatch, updateToasts });
}